(ns quuppa.peweb.mapview-events
  (:require [clojure.string :as str]
            [re-frame.core :as rf :refer [reg-event-db reg-event-fx reg-fx]]
            [quuppa.frontend-utils :as utils]))

(def default-map-state
  {:view :3d})

(def query-parameters
  [:map
   [:view {:optional true} :keyword]
   [:cs-id {:optional true} :string]
   [:selected {:optional      true
               :decode/string (fn [v]
                                (let [[a b] (str/split v #":")]
                                  {:type a
                                   :id   b}))}
    [:map
     [:type :keyword]
     [:id :string]]]])

(reg-event-db
  :map/assoc-in
  (fn [db [_ ks v]]
    (update db :map assoc-in ks v)))

; automatically called after handshake completed
;; FIXME: wrong namespace
(reg-event-fx
  :connection/established
  (fn event-connection-established
    [_ [_]]
    ; TODO perhaps these are locally cached, for now just as an example
    {:fx [[:server-dispatch [:connection/req-set-preferences {:min-change-updates-interval 200}]]]}))

(reg-event-fx
  :connection/change-preferences
  (fn event-connection-change-preferences
    [_ [_ preferences]]
    ; TODO Use spec
    ; TODO perhaps these are locally cached, for now just as an example
    {:fx [[:server-dispatch [:connection/req-set-preferences preferences]]]}))

;; FIXME: Is this used anywhere?
(reg-event-db
  :tag/location-changed
  (fn event-tag-location-changed
    [db [_ _tag-location-map]]
    (js/console.warn "tag/location-changed event, shouldn't be used?")
    db))

(reg-event-db
  :tag/removed
  (fn event-tag-removed
    [db [_ qpe-identity removed-tag]]
    (update-in db [:qpes qpe-identity :tags] (fn [v]
                                               (-> v
                                                   (update :info dissoc (:resolved-id removed-tag))
                                                   (update :location dissoc (:resolved-id removed-tag)))))))

(reg-event-db
  :tag/added
  (fn event-tag-added
    [db [_ qpe-identity added-tag]]
    ; the difference between location-changed and tag/add is that no tag info is included in the former
    (update-in db [:qpes qpe-identity :tags] (fn [v]
                                               (-> v
                                                   (update :info assoc (:resolved-id added-tag) (dissoc added-tag :location))
                                                   (update :location assoc (:resolved-id added-tag) (:location added-tag)))))))

;; TODO: Consider replacing :map/cs-locations subscriptions with efficient data structure storing
;; cs-id => tag-id => location.
;; This needs changes in the :tags/locations-changed event format on the backend, so that event can
;; update the app-db fast.
(reg-event-db
  :tags/locations-changed
  (fn event-tags-locations-changed
    [db [_ qpe-identity tag-locations]]
    (update-in db [:qpes qpe-identity :tags :location]
               (fn event-tags-locations-changed-update [locations]
                 (persistent!
                   (reduce (fn event-tags-locations-changed-update-reduce [locations tag-update-map]
                             (let [tag-id (:resolved-id tag-update-map)]
                               (assoc! locations tag-id (:location tag-update-map))))
                           (transient (or locations {}))
                           tag-locations))))))

(reg-event-fx
  :map-ui/select-cs
  (fn event-map-ui-select-cs
    [_ [_ cs-id]]
    {:fx [[:update-query [assoc :cs-id cs-id]]]}))

(reg-event-db
  :tags/info-all
  (fn event-tags-info-call
    [db [_ qpe-identity tag-data]]
    (let [location-data (into {} (map (juxt key (comp :location val)) tag-data))
          info-data (into {} (map (juxt key #(dissoc (val %) :location)) tag-data))]
      (assoc-in db [:qpes qpe-identity :tags] {:info info-data
                                               :location location-data}))))
(rf/reg-fx
  :update-local-storage
  (fn [{:keys [current-site-key preferences]}]
    (let [local-storage-item (utils/get-item! current-site-key)
          updated-preference (if (seq local-storage-item)
                               (merge local-storage-item preferences)
                               preferences)]
      (utils/set-item! current-site-key updated-preference))))

(reg-event-fx
  :map/save-preferences
  (fn [{:keys [db]} [_ {:keys [current-site-key preferences]}]]
    {:db (update-in db [:map/preferences current-site-key] merge preferences)
     :fx [[:update-local-storage {:current-site-key current-site-key
                                  :preferences preferences}]]}))
